module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.300215a1.svg";